import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconButton, TableCell, TableRow, useTheme } from '@mui/material';
import { Text } from 'components/text';
import { ChargeSetting } from 'graphql/charge-settings/queries';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import {
  defaultForAll, formatPartyLabel, formatPercentLabel, getSettingName
} from 'views/charge-settings/utils';

type RowProps = {
  setting: ChargeSetting,
  onDelete: (settingId: string) => void
  onEdit: (setting: ChargeSetting) => void,
};

export const Row: FC<RowProps> = ({
  setting,
  onDelete,
  onEdit
}) => {
  const {
    payees,
    payers,
    buyer_before,
    buyer_at,
    seller_before,
    seller_at,
    by_others,
    amount_override
  } = setting;
  const theme = useTheme();
  const { t } = useTranslation();
  const settingName = getSettingName(setting);

  return (
    <>
      <TableRow hover key={setting._id}>
        <TableCell>
          <Text value={settingName} isMoney color="textPrimary" />
        </TableCell>
        <TableCell>
          <Text value={formatPartyLabel(payees)} color="textPrimary" />
        </TableCell>
        <TableCell>
          <Text value={formatPartyLabel(payers)} color="textPrimary" />
        </TableCell>
        <TableCell>
          <Text value={formatPercentLabel(buyer_before)} color="textPrimary" />
        </TableCell>
        <TableCell>
          <Text value={formatPercentLabel(buyer_at)} color="textPrimary" />
        </TableCell>
        <TableCell>
          <Text value={formatPercentLabel(seller_before)} color="textPrimary" />
        </TableCell>
        <TableCell>
          <Text value={formatPercentLabel(seller_at)} color="textPrimary" />
        </TableCell>
        <TableCell>
          <Text value={formatPercentLabel(by_others)} color="textPrimary" />
        </TableCell>
        <TableCell>
          <Text value={amount_override} color="textPrimary" isMoney />
        </TableCell>
        <TableCell>
          <IconButton
            aria-label={`${t('common:edit')} ${settingName}`}
            onClick={() => onEdit(setting)}
            size="large"
          >
            <FontAwesomeIcon icon="edit" size="xs" color={theme.palette.secondary.main} />
          </IconButton>
          {settingName !== defaultForAll && (
          <IconButton
            aria-label={`${t('common:delete')} ${settingName}`}
            onClick={() => onDelete(setting._id)}
            size="large"
          >
            <FontAwesomeIcon icon="trash" size="xs" color={theme.palette.error.main} />
          </IconButton>
          )}
        </TableCell>
      </TableRow>
    </>
  );
};
